<template>
	<a href="/#section-reservations"> <slot /> </a>
</template>

<script setup></script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
